export const VERSION = "22.0.5";
export const RELEASE = "checkout@22.0.5";
